import { Card, CardContent, Grid, Typography } from '@mui/material';
import React from 'react';

const CobranzaOnlineDialogDetails = (props: any) => {
  const { packages } = props;
  return (
    <div style={{ paddingTop: '10px' }}>
      <Typography variant="h6">Pricing</Typography>
      <Grid container spacing={2}>
        {packages.map((element: any) => (
          <Grid item xs={4} key={element.id} style={{ display: 'flex' }}>
            <Card sx={{ borderRadius: 2 }}>
              <CardContent>
                <Typography variant="h6">
                  {element.fixedCost} UF / mes
                </Typography>
                <Typography variant="body1">{element.description}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default CobranzaOnlineDialogDetails;
